`<template>
  <div :style="{'width':size+'px', 'height':size+'px'}" class="user-photo">
    <div class="user-photo-dummy" :class="{'user-photo-dummy_white':theme=='white'}">
      <i class="icon man" :style="{'font-size':(size/2.33)+'px'}"></i>
    </div>

    <template v-if="link">
      <router-link :to="link" :title="validSrc">
        <div class="user-photo-frame" :style="{backgroundImage: validSrc}"></div>
      </router-link>
    </template>

    <template v-else>
      <div class="user-photo-frame" :style="{backgroundImage: validSrc}"></div>
    </template>
  </div>
</template>

<script>
  export default {
    props: ['src', 'size', 'link', 'theme', 'alias'],
    computed: {
      validSrc() {
        const value = ((this.alias && this.src) ? this.src[this.alias] : this.src) || this.src;
        const returnData = value ? `url(${value})` : 'none';
        return returnData;
      }
    }
  }
</script>

<style src="./style.scss" lang="scss" scoped/>
